"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Pane_1 = require("./Pane");
exports.Pane = Pane_1.default;
var paneOptions_1 = require("./paneOptions");
exports.paneOptions = paneOptions_1.default;
//# sourceMappingURL=index.js.map